<template>
  <v-card :disabled="isDisabled">
    <UserBadge :have-permissions="!isDisabled" :read-only="!canWrite"/>
    <v-card-title class="ctd-title">
      <div class="mr-2">{{ $t('settings.clickToDial.title') }}</div>
      <cp-help i18n="clickToDial"/>
    </v-card-title>
    <v-card-text class="pr-8">
      <v-select class="ctc-destination"
        :disabled="!canWrite"
        prepend-icon="mdi-arrow-decision"
        v-model="destination"
        :items="destinationList"
        item-text="label"
        item-value="id"
        :label="$t('settings.clickToDial.labelDestination')"
      ></v-select>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text @click="installCallHandler">
        {{ $t('settings.clickToDial.installCallHandler') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserBadge from '../user_badge'

export default {
  name: 'settings-click-to-dial',
  data () {
    return {
      defaultDestination: 'softphoneShow'
    }
  },
  components: { UserBadge },
  computed: {
    ...mapGetters({
      ctdWrite: 'permissions/ctdWrite',
      ctdWriteFor: 'permissions/ctdWriteFor',
      activeSubAccount: 'settings/activeSubAccount',
      isOwnerCurUser: 'settings/isOwnerCurUser',
      ctdData: 'settings/clickToDial',
      sipUser: 'sipua/exten'
    }),
    destination: {
      get: function () {
        return this.getDestinationValue(this.ctdData.destination)
      },
      set: function (val) {
        this.updateClickToDial(val)
      }
    },
    isDisabled: function () {
      if (!this.activeSubAccount || this.isOwnerCurUser) {
        return false
      }
      return !this.activeSubAccount.features?.includes('click_to_dial')
    },
    canWrite: function () {
      if (!this.activeSubAccount || this.isOwnerCurUser) {
        return this.ctdWrite
      }
      return this.ctdWriteFor(this.activeSubAccount?.subscriber_id)
    },
    destinationList: function () {
      return [
        { id: 'softphoneShow', label: this.$t('settings.clickToDial.destinationTypes.softphoneShow') },
        { id: 'callPanelDial', label: this.$t('settings.clickToDial.destinationTypes.callPanelDial') },
        { id: 'dialAfterOriginate', label: this.$t('settings.clickToDial.destinationTypes.dialAfterOriginate') }
      ]
    }
  },
  methods: {
    ...mapActions({
      setClickToDial: 'settings/setClickToDial',
      installCallHandler: 'installCallHandler'
    }),
    getDestinationValue: function (id) {
      const list = this.destinationList
      const val = list.find(l => l.id === id)
      if (!val) return this.defaultDestination
      return val
    },
    updateClickToDial: function (val) {
      this.setClickToDial({ destination: val })
    }
  }
}
</script>

<style scoped>
</style>
